import { render, staticRenderFns } from "./categoryAdd.vue?vue&type=template&id=2d576997&scoped=true"
import script from "./categoryAdd.vue?vue&type=script&lang=js"
export * from "./categoryAdd.vue?vue&type=script&lang=js"
import style0 from "./categoryAdd.vue?vue&type=style&index=0&id=2d576997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d576997",
  null
  
)

export default component.exports